"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/no-explicit-any */
const react_1 = __importStar(require("react"));
const Modal_1 = __importDefault(require("components/design-system/Modal"));
const HelperUtils_1 = require("src/utils/HelperUtils");
const ProfileType_1 = __importDefault(require("../design-system/ProfileType"));
const Checkbox_1 = __importDefault(require("../shared/Checkbox"));
const ModalConfirmNewSquadMembers = ({ onClose, teamData, getNotInvolvedUsersInSquad, checkNextStep, newSquadMembersIds, setNewSquadMembersIds }) => {
    const { permissions } = teamData || {};
    const users = getNotInvolvedUsersInSquad();
    const [selectedIds, setSelectedIds] = (0, react_1.useState)(newSquadMembersIds);
    const [isProfileTypeRendered, setIsProfileTypeRendered] = (0, react_1.useState)(false);
    const onClickCheckbox = (userId) => {
        let currentSelectedIds = [...selectedIds];
        if (currentSelectedIds === null || currentSelectedIds === void 0 ? void 0 : currentSelectedIds.includes(userId)) {
            // ** Remove selected user id
            currentSelectedIds = currentSelectedIds.filter((id) => id !== userId);
        }
        else {
            // ** Append selected user id
            currentSelectedIds.push(userId);
        }
        setSelectedIds(currentSelectedIds);
    };
    const onClickPrimaryBtn = () => {
        checkNextStep(true);
        onClose();
        setNewSquadMembersIds(selectedIds);
    };
    (0, react_1.useEffect)(() => {
        // ** Need this timeout to fix small font-size in react-avatar
        setTimeout(() => {
            setIsProfileTypeRendered(true);
        }, 75);
    }, []);
    return (react_1.default.createElement(Modal_1.default, { onClose: onClose, minWidth: 400, customClass: "!max-w-[400px]" },
        react_1.default.createElement(Modal_1.default.Header, { title: (0, HelperUtils_1.getObjectiveLocale)('New Squad Members'), onClose: onClose }),
        react_1.default.createElement(Modal_1.default.Body, null,
            react_1.default.createElement("div", { className: "px-[24px] py-[4px]" },
                react_1.default.createElement("p", { className: "typography-paragraph text-n-800" },
                    (0, HelperUtils_1.getObjectiveLocale)('These users are not involved in'),
                    ' ',
                    react_1.default.createElement("span", { className: "typography-h400 text-n-900" }, teamData === null || teamData === void 0 ? void 0 : teamData.name),
                    ' ',
                    (0, HelperUtils_1.getObjectiveLocale)(`squad. ${(permissions === null || permissions === void 0 ? void 0 : permissions.includes('change_member'))
                        ? 'Which users would you want to add as squad members? They will be added after the project is created.'
                        : 'You might need to inform the squad leader about their involvement in case they need to be added as squad members.'}`)),
                react_1.default.createElement("div", { className: "bg-n-200 rounded-[4px] mt-[10px]" }, users.map((user) => {
                    var _a, _b, _c;
                    return (react_1.default.createElement("div", { className: "flex items-center justify-between h-[48px] py-[8px] px-[16px]", key: user === null || user === void 0 ? void 0 : user.userId },
                        isProfileTypeRendered && (react_1.default.createElement(ProfileType_1.default, { user: { name: (_a = user === null || user === void 0 ? void 0 : user.user) === null || _a === void 0 ? void 0 : _a.name }, title: (_b = user === null || user === void 0 ? void 0 : user.user) === null || _b === void 0 ? void 0 : _b.name, subtitle: (_c = user === null || user === void 0 ? void 0 : user.user) === null || _c === void 0 ? void 0 : _c.jobTitle, customClass: "w-[calc(100%-36px)]", titleClassName: "typography-h400", subtitleClassName: "typography-h100 text-n-800", size: 32, truncateSubtitle: true })),
                        (permissions === null || permissions === void 0 ? void 0 : permissions.includes('change_member')) && (react_1.default.createElement(Checkbox_1.default, { id: user === null || user === void 0 ? void 0 : user.userId, name: user === null || user === void 0 ? void 0 : user.userId, checked: selectedIds === null || selectedIds === void 0 ? void 0 : selectedIds.includes(user === null || user === void 0 ? void 0 : user.userId), onClick: () => onClickCheckbox(user === null || user === void 0 ? void 0 : user.userId) }))));
                })))),
        react_1.default.createElement(Modal_1.default.Footer, { useBorder: false, primaryButton: {
                text: (permissions === null || permissions === void 0 ? void 0 : permissions.includes('change_member')) ? 'Confirm' : 'OK',
                onClick: onClickPrimaryBtn
            } })));
};
exports.default = ModalConfirmNewSquadMembers;
